import React, { Component } from 'react';
import { array, bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';

import { FormattedMessage } from '../../util/reactIntl';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { convertImagesToPublicDataInfo } from '../../forms/EditListingPhotosForm/utils';
import { ensureOwnListing } from '../../util/data';
import { updateProfileImageMaybe } from './utils';

import { EditListingPhotosForm } from '../../forms';
import { ListingLink } from '../../components';

import css from './EditListingPhotosPanel.module.css';

class EditListingPhotosPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // initialValues: this.getInitialValues(),
      firstImageFromState: null,
    };
  }

  // getInitialValues() {
  //   const { listing, currentUser, images } = this.props;
  //   const currentListing = ensureOwnListing(listing);
  //   const { publicData } = currentListing.attributes;

  //   return {
  //     images,
  //     videoTitle: publicData?.videoTitle,
  //     youtubeLink: publicData?.youtubeLink,
  //     videos: publicData?.videos,
  //     differentiationFromCompetitors: publicData?.differentiationFromCompetitors,
  //     associationTitle: publicData?.associationTitle,
  //     associations: publicData.associations ? [...publicData.associations, undefined] : [undefined],
  //     qualificationTitle: publicData?.qualificationTitle,
  //     qualifications: publicData.qualifications ? [...publicData.qualifications, undefined] : [undefined],
  //     files: publicData.files ? [...publicData.files, undefined] : [undefined],
  //     phoneNumber: publicData?.phoneNumber,
  //     companySize: publicData?.companySize,
  //     geographicalFocus: publicData.geographicalFocus ? [...publicData.geographicalFocus] : [undefined],
  //     operatingSince: publicData?.operatingSince,
  //   };
  // }

  handleSetFirstImage = (file) => {
    if (file) {
      this.setState({ firstImageFromState: [file] })
    } else {
      this.setState({ firstImageFromState: null })
    }
  }

  render() {
    const {
      className,
      rootClassName,
      errors,
      disabled,
      ready,
      images,
      listing,
      onImageUpload,
      onUpdateImageOrder,
      submitButtonText,
      panelUpdated,
      updateInProgress,
      onChange,
      onSubmit,
      onRemoveImage,
      currentUser,
      onUpdateProfile,
      isProvider,
      isDraftListing,
      previewPopupData,
      onHandlePreviewPopup,
      onHandleCreateAndBublishListing,
    } = this.props;

    const rootClass = rootClassName || css.root;
    const classes = classNames(rootClass, className);
    const currentListing = ensureOwnListing(listing);
    const isClient = currentUser?.attributes?.profile?.publicData?.userType === 'client';

    const isPublished =
      currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
    const panelTitle = isPublished ? (
      <FormattedMessage
        id="EditListingPhotosPanel.title"
        values={{
          listingTitle: (
            <ListingLink listing={listing}>
              <FormattedMessage id="EditListingPhotosPanel.listingTitle" />
            </ListingLink>
          ),
        }}
      />
    ) : (
      <FormattedMessage id="EditListingPhotosPanel.createListingTitle" />
    );

    const publicData = get(currentListing, 'attributes.publicData', null);
    const previewValues = previewPopupData?.values;

    return (
      <div className={classes}>
        <h1 className={css.title}>
          {panelTitle}
          {/* {isClient && ' (Optional)'} */}
        </h1>
        <EditListingPhotosForm
          className={css.form}
          disabled={disabled}
          ready={ready}
          fetchErrors={errors}
          // initialValues={this.state.initialValues}
          initialValues={{
            images,
            videoTitle: previewValues?.videoTitle || publicData?.videoTitle,
            youtubeLink: previewValues?.youtubeLink || publicData?.youtubeLink,
            videos: previewValues?.videos || publicData?.videos,
            differentiationFromCompetitors: previewValues?.differentiationFromCompetitors || publicData?.differentiationFromCompetitors,
            associationTitle: previewValues?.associationTitle || publicData?.associationTitle,
            associations: previewValues?.associations || ((!!publicData?.associations?.length && [...publicData?.associations, undefined]) || [undefined]),
            qualificationTitle: previewValues?.qualificationTitle || publicData?.qualificationTitle,
            qualifications: previewValues?.qualifications || ((!!publicData?.qualifications?.length && [...publicData?.qualifications, undefined]) || [undefined]),
            files: previewValues?.files || ((!!publicData?.files?.length && [...publicData.files, undefined]) || [undefined]),
            phoneNumber: previewValues?.phoneNumber || publicData?.phoneNumber,
            companySize: previewValues?.companySize || publicData?.companySize,
            geographicalFocus: previewValues?.geographicalFocus || ((!!publicData?.geographicalFocus?.length && [...publicData?.geographicalFocus]) || [undefined]),
            operatingSince: previewValues?.operatingSince || publicData?.operatingSince,
          }}

          images={images}
          onImageUpload={onImageUpload}
          onSubmit={async values => {
            const {
              addImage,
              youtubeLink,
              videoTitle,
              videos,
              differentiationFromCompetitors,
              files,
              associationTitle,
              associations,
              qualificationTitle,
              qualifications,
              phoneNumber,
              companySize,
              geographicalFocus,
              operatingSince,
              ...updateValues
            } = values;
            const imagesPulicDataInfo = convertImagesToPublicDataInfo(values?.images, publicData);

            const filteredFiles = files?.filter(f => f);
            const filteredAssociations = associations?.filter(a => !!a);
            const filteredQualifications = qualifications?.filter(q => !!q);

            let finalValues = {
              publicData: {
                videoTitle,
                youtubeLink,
                videos: !!videos?.length ? videos.reverse() : null,
                differentiationFromCompetitors: !!differentiationFromCompetitors?.length ? differentiationFromCompetitors : null,
                files: filteredFiles.length ? filteredFiles.reverse() : null,
                associationTitle: !!associationTitle?.trim()?.length ? associationTitle : null,
                associations: filteredAssociations.length ? filteredAssociations : null,
                qualificationTitle: !!qualificationTitle?.trim()?.length ? qualificationTitle : null,
                qualifications: filteredQualifications.length ? filteredQualifications : null,
                phoneNumber: !!phoneNumber?.trim()?.length ? phoneNumber : null,
                companySize: !!companySize?.length ? companySize : null,
                geographicalFocus: !!geographicalFocus?.length ? geographicalFocus : null,
                operatingSince: !!operatingSince?.length ? operatingSince : null,
                ...imagesPulicDataInfo,
              },
              ...updateValues,
            };

            const firstImage = values.images.filter(
              img => typeof img.id === 'string' && img.id?.includes('backgroundPhoto-')
            );

            const newImages = values.images.filter(
              img => typeof img.id === 'string' && !img.id?.includes('backgroundPhoto-')
            );

            const savedImages = values.images.filter(img => !!img?.id?.uuid)

            finalValues.images = [...firstImage, ...savedImages, ...newImages];

            finalValues.publicData.backgroundPhotoIds = !!firstImage?.length &&
              (finalValues?.images?.[0]?.id?.uuid || finalValues?.images?.[0]?.imageId?.uuid) || publicData?.backgroundPhotoIds;

            // return updateProfileImageMaybe(logoImageFile, onUpdateProfile)
            return updateProfileImageMaybe(null)
              .then(resp => {
                return onSubmit(finalValues);
              })
              .then(resp => {
                return onHandlePreviewPopup(false, null, null);
              })
              // .then(resp => {
              //   return onUpdateProfile(
              //     { publicData: { referralLink: !!referralLink?.trim()?.length ? referralLink : null } }
              //   )
              // })
              .catch(e => console.log(e));
          }}
          onChange={onChange}
          onUpdateImageOrder={onUpdateImageOrder}
          onRemoveImage={onRemoveImage}
          saveActionMsg={submitButtonText}
          updated={panelUpdated}
          updateInProgress={updateInProgress}
          isClient={isClient}
          isDraftListing={isDraftListing}
          listing={currentListing}
          currentUser={currentUser}
          onUpdateProfile={onUpdateProfile}
          handleSetFirstImage={this.handleSetFirstImage}
          firstImageFromState={this.state.firstImageFromState}
          isProvider={isProvider}
          onHandlePreviewPopup={onHandlePreviewPopup}
          onHandleCreateAndBublishListing={onHandleCreateAndBublishListing}
        />
      </div>
    );
  }
}

EditListingPhotosPanel.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  images: [],
  listing: null,
};

EditListingPhotosPanel.propTypes = {
  className: string,
  rootClassName: string,
  errors: object,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  images: array,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  onImageUpload: func.isRequired,
  onUpdateImageOrder: func.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  onRemoveImage: func.isRequired,
};

export default EditListingPhotosPanel;
